import { render, staticRenderFns } from "./associate_guardian.vue?vue&type=template&id=65583a4f&"
import script from "./associate_guardian.vue?vue&type=script&lang=js&"
export * from "./associate_guardian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports